import { Label as LabelUI } from '@/components/ui/label';
import React, { forwardRef } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { twJoin } from 'tailwind-merge';
import Typo, { typoColorData, typoTypeData } from '../Typo';

const labelSizeData = {
  M: 'text-b16m',
  S: 'text-b14m',
};

export interface LabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  required?: boolean;
  labelSize?: keyof typeof labelSizeData;
  typoClassName?: string;
  typoColor?: keyof typeof typoColorData;
  typoType?: keyof typeof typoTypeData;
}

const Label = forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(
  (
    {
      labelSize = 'M',
      typoColor = 'gary7',
      typoType,
      required,
      children,
      className,
      typoClassName,
      ...props
    },
    ref,
  ) => {
    return (
      <LabelUI
        ref={ref}
        className={twJoin(labelSizeData[labelSize], className)}
        {...props}
      >
        <Typo
          typoType={typoType ? typoType : labelSize === 'M' ? 'b16m' : 'b14m'}
          typoColor={typoColor as keyof typeof typoColorData}
          className={typoClassName}
        >
          {children}
        </Typo>

        {required && (
          <span className="pl-[2px] text-b16m leading-[16px] text-red5">*</span>
        )}
      </LabelUI>
    );
  },
);

export default Label;
